import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';
import { log } from 'mathjs';

export class ParticipationCertificateModel {
    public activityId: number;
    public cover: string;
    public name: string;
    public sign_up_start_date: string;
    public sign_up_finish_date: string;
    public start_date: string;
    public finish_date: string;
    public level: string;
    public finished: boolean;
    public certs: ParticipationCertificates.CertItem[];
    /** 张数 */
    public count: number;

    public constructor(raw: ParticipationCertificates.ActivityList) {
        this.activityId = raw.activity_id;
        this.cover = raw.cover;
        this.name = raw.name;
        this.sign_up_start_date = raw.sign_up_start_date;
        this.sign_up_finish_date = raw.sign_up_finish_date;
        this.start_date = raw.start_date;
        this.finish_date = raw.finish_date;
        this.level = raw.level;
        this.finished = raw.finished;
        this.certs = raw.certs  || [];
        this.count = raw.count || 0;
    }

    /** 是否开始报名 */
    public get startParticipation() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateParse(this.sign_up_start_date).valueOf();
    }
    /** 是否结束报名 */
    public get closeParticipation() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateOffset(dateParse(this.sign_up_finish_date), 1).valueOf();
    }
    /** 是否开始打卡 */
    public get startSignIn() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateParse(this.start_date).valueOf();
    }
    /** 是否结束打卡 */
    public get closeSignIn() {
        const timestamp = serverDateNow().valueOf();
        return timestamp >= dateOffset(dateParse(this.finish_date), 1).valueOf();
    }
    /** 标签文本 */
    public get tag() {
        if (!this.startParticipation) {
            return '未开始';
        } else if (!this.closeParticipation && !this.startSignIn) {
            return '报名中';
        } else if (this.startSignIn && !this.closeSignIn) {
            return '进行中';
        } else if (this.closeSignIn) {
            return '已结束';
        }
    }
    /** 是否完赛 */
    public get isFinish() {
        return this.finished;
    }
}
